import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import css from './index.module.scss';

interface RenderParams {
  index: number;
  rectWidth: number;
}

interface Props<X> {
  width: number;
  xScale: (xValue: X) => number;
  xTicks: X[];
  overlay: HTMLDivElement | null;
  children: (params: RenderParams) => React.ReactNode;
}

export const HoverZone = <X,>({ width, xScale, xTicks, overlay, children }: Props<X>) => {
  const [index, setIndex] = useState<number | null>(null);
  const rectWidth = Math.max(Math.ceil(width / xTicks.length) + 1, 0); // Add some "slop" to eliminate dead hover zones

  return (
    overlay &&
    createPortal(
      <div className={css.hoverZone} onMouseLeave={() => setIndex(null)}>
        {xTicks.map((t, i) => (
          <div
            key={i}
            className={css.hoverZoneRect}
            style={{ left: xScale(t) - rectWidth, width: rectWidth }}
            onMouseEnter={() => setIndex(i)}
          >
            {index === i && children({ index, rectWidth })}
          </div>
        ))}
      </div>,
      overlay,
    )
  );
};
